module.exports = __webpack_public_path__ + "static/media/Devika.b889f123.jpg";